import { AxiosResponse } from 'axios';
import { DocumentRegistryForm } from 'civil-status/components/document-registry/form';
import { DocumentRegistry } from 'shell/models/document-registry';
import { HttpResponse } from 'shell/models/http-response';

export const transformResponseDocumentRegistry = (
  response: AxiosResponse<HttpResponse<DocumentRegistry>>
): DocumentRegistryForm => {
  const responseData = response.data.payload;
  return {
    number: responseData?.key?.codiceRegistro || '',
    description: responseData?.registro || '',
  };
};
